var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.isLoaded)?_c('router-view'):_c('div',{staticClass:"app-loading"},[_c('Spin',{attrs:{"size":"large","fix":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }